import * as React from 'react';
import type { SubjectOverlayActionProps } from '../SubjectOverlayAction/SubjectOverlayAction';
import { SubjectOverlayAction } from '../SubjectOverlayAction/SubjectOverlayAction';
import { AlertSectionVariant } from '~/Blocks/AlertSectionBlock/AlertSectionVariant.csharp';
import type { HtmlString } from '~/Features/Types/HtmlString.csharp';
import { AlertSection } from '~/Partials/AlertSection/AlertSection';
import { HtmlDiv } from '~/Partials/Controls/HtmlDiv';
import styles from './SubjectOverlayContent.module.css';

export interface SubjectOverlayAlert {
    heading?: string;
    message?: HtmlString;
    variant?: AlertSectionVariant;
}

export interface SubjectOverlayContentMessages {
    outdated: SubjectOverlayAlert;
    fallback: SubjectOverlayAlert;
}

export interface SubjectOverlayContentProps extends SubjectOverlayActionProps {
    subjectName: string;
    messages: SubjectOverlayContentMessages;
    subjectDescription?: HtmlString;
    isDescriptionOutdated?: boolean;
}

export const SubjectOverlayContent: React.FC<SubjectOverlayContentProps> = props => {
    const { subjectName, subjectDescription, messages, isDescriptionOutdated, ...restProps } = props;

    const subjectHasDescription = subjectDescription && subjectDescription.value;

    const renderAlert = (alert: SubjectOverlayAlert) => (
        <div className={styles.Alert}>
            <AlertSection headerType="h4" header={alert.heading} variant={alert.variant ?? AlertSectionVariant.Warning}>
                {alert.message && <HtmlDiv html={alert.message} />}
            </AlertSection>
        </div>
    );

    return (
        <div>
            <h3 className={styles.Heading}>{subjectName}</h3>
            {subjectHasDescription && isDescriptionOutdated && renderAlert(messages.outdated)}
            {subjectHasDescription ? (
                <HtmlDiv className={styles.Description} html={subjectDescription} />
            ) : (
                messages.fallback.heading && renderAlert(messages.fallback)
            )}
            <SubjectOverlayAction {...restProps} />
        </div>
    );
};
